import GalleriesContainer from 'components/Galleries/GalleriesContainer'
import GalleriesPresentation from 'components/Galleries/GalleriesPresentation'

export default {
  Container: GalleriesContainer,
  Presentation: GalleriesPresentation,
}
